export function switchToProfile(userId) {
  localStorage.setItem('currentUserId', userId);
  setTimeout(() => window.location.reload(), 200);
  return;
}
